module.exports = __webpack_public_path__ + "img/googleplay.5b5388e7.png";